import React from "react";
import PropTypes from "prop-types";
import "./style.scss";

const CLASSNAMES = {
  CORRECT: "correct",
  INCORRECT: "incorrect",
};

export class NumericEntry extends React.Component {
  renderFeedback() {
    let feedback;
    this.props.feedback.forEach((item) => {
      if (
        (item.range[0] === -1 ||
          parseFloat(this.props.savedEntry, 10) >= item.range[0]) &&
        (item.range[1] === -1 ||
          parseFloat(this.props.savedEntry, 10) <= item.range[1])
      ) {
        feedback = item.feedback;
      }
    });

    if (feedback) {
      return (
        <p
          className={
            this.props.isCorrect ? CLASSNAMES.CORRECT : CLASSNAMES.INCORRECT
          }
        >
          {feedback}
        </p>
      );
    } else {
      return null;
    }
  }

  updateNumericEntry = (event) => {
    event.stopPropagation();

    if (event.target.value !== null) {
      const payload = {
        componentID: this.props.componentID,
        numericEntry: event.target.value,
      };

      this.props.responseNEQChange(payload);
    }
  };

  wrapperClass() {
    const classList = [this.props.className, "numericEntry"];
    if (this.props.disabled) {
      if (this.props.isCorrect) classList.push(CLASSNAMES.CORRECT);
      else classList.push(CLASSNAMES.INCORRECT);
    }
    return classList.join(" ");
  }

  render() {
    return (
      <>
        <div className={this.wrapperClass()}>
          <input
            type="number"
            className="textarea-input"
            onChange={(e) => this.updateNumericEntry(e)}
            value={this.props.numericEntry}
            disabled={this.props.disabled}
            placeholder="Answer here."
          />
        </div>
        {this.renderFeedback()}
      </>
    );
  }
}
NumericEntry.propTypes = {
  className: PropTypes.string,
  componentID: PropTypes.number,
  feedback: PropTypes.string,
  id: PropTypes.number,
  isCorrect: PropTypes.bool,
  disabled: PropTypes.bool,
  responseNEQChange: PropTypes.func,
};
